import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { RutaService } from 'src/app/services/operaciones/ruta.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-detalle-controlador-zam',
  templateUrl: './detalle-controlador-zam.component.html',
  styleUrls: [ './detalle-controlador-zam.component.scss','../../estilosModales.scss']
})
export class DetalleControladorZamComponent implements OnInit {
  public displayedColumns = ['ruta',
    'viaje',
    'cliente',
    'operador',
    'unidad',
    'tipoOperacion',
    'fechaCarga',
    'horaCarga',
    'fechaCita',
    'horaCita',
    'origen',
    'destino',
    'estatus',
    'anticipos',
    'vales',
    'ccpTimbrado'
  ];
  dataSource: Array<any> = [];
  evidencias: Array<any> = [];

  constructor(
    public dialogRef: MatDialogRef<DetalleControladorZamComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _rs: RutaService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    console.log(this.data);
    this.dataSource = this.data;
    // this.consultarParadasvisitadas();
  }

  // consultarParadasvisitadas() {
  //   this._rs.consultarParadasVisitadas(this.data.idRuta).subscribe(
  //     result => {
        
  //       this.dataSource = result;
  //        for(let obj of this.dataSource) {
  //          if(obj.horas < 0){
  //            obj.color = "rojo"
  //          }else{
  //            obj.color = "verde"
  //          }

  //          if(obj.minutos < 10){
  //            obj.total = +obj.horas + ':0' + +obj.minutos
  //          }else{
  //             obj.total = +obj.horas + ':' + +obj.minutos
  //          }
  //        }
  //       console.log(this.evidencias);
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   );
  // }

  // exportarPDF(){
  //   this._rs.exportarPDF(this.dataSource).subscribe(
  //  result => {
  //       this.downLoadFile(result);
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //     );
  // }

  cerrarModal() {
    this.dialogRef.close();
  }
  
  // downLoadFile(data:any){
  //      const linkSource = 'data:application/pdf;base64,' + data
  //       const downloadLink = document.createElement("a");
  //       const fileName = "Informacion de la Parada.pdf";

  //       downloadLink.href = linkSource;
  //       downloadLink.download = fileName;
  //       downloadLink.click();
  //   }  

}
